import Footer from '@/components/layout/footer';
import { NavbarPublic as Navbar } from '@/components/layout/navbar/navbar.public';
import { BookingCleaning } from '@/features/consumer/booking-cleaning';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const bookingSearchSchema = z.object({
  address_id: z.string().optional(),
});

export const Route = createFileRoute('/(consumer)/(bookings)/booking')({
  component: LayoutBookingCleaning,
  validateSearch: bookingSearchSchema,
});

function LayoutBookingCleaning() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="mt-[80px] md:mt-[140px]">
        <BookingCleaning />
      </div>
      <Footer />
    </div>
  );
}
